// @flow

import React from 'react';

import styles from './BorderedBoxRadio.module.css';
import cx from 'classnames';

type Props = {
  name: string,
  id?: string,
  label: string,
  value: string | number | boolean,
  onChange: Function,
  defaultChecked?: boolean,
  isRequired?: boolean,
  isError?: boolean
};

const convertType = (typedValue, toBeConverted) => {
  switch (typeof typedValue) {
    case 'string':
      return toBeConverted;
    case 'boolean':
      return toBeConverted === 'true';
    case 'number':
      return +toBeConverted;
    default:
      return toBeConverted;
  }
};

const BorderedBoxRadio = ({
  name,
  id,
  label,
  value,
  onChange,
  defaultChecked = false,
  isRequired = false,
  isError = false
}: Props) => (
  <label
    className={cx(styles.borderedBoxRadioLabel, { [styles.error]: isError })}
    htmlFor={id || value.toString()}>
    <input
      type='radio'
      className={styles.borderedBoxRadioInput}
      id={id || value.toString()}
      required={isRequired}
      defaultChecked={defaultChecked}
      value={value}
      name={name}
      aria-invalid={isError}
      onChange={(e) => onChange(convertType(value, e.target.value))}
    />
    {label}
  </label>
);

export default BorderedBoxRadio;
